var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"label":"Customer"}},[_c('b-input',{attrs:{"size":"is-small"},on:{"change":_vm.save},model:{value:(_vm.selected_customer),callback:function ($$v) {_vm.selected_customer=$$v},expression:"selected_customer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }